var _path, _path2, _path3, _path4, _path5, _path6, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordOn2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8647 11C19.5889 8.79508 18.5604 6.77083 16.9708 5.30439C15.3813 3.83794 13.3391 3.02932 11.2247 3.02917C9.11037 3.02902 7.06806 3.83736 5.47832 5.30358C3.88857 6.7698 2.8598 8.79391 2.58368 10.9988",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2605 3.5L16.8451 0.999985",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4294 6.8335L20.9985 5.51977",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4294 6.8335L20.9985 5.51977",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56909 6.8335L1 5.51977",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54565 1L8.13022 3.50002",
    stroke: "#5A8FC3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 10.5,
    r: 2.75,
    stroke: "#5A8FC3",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordOn2);
export default __webpack_public_path__ + "static/media/password-on-2.cb321b4545316717f7bd142d234c851b.svg";
export { ForwardRef as ReactComponent };